import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterPanel = ({
  filters,
  onFilterChange,
  onClearFilters,
  isCollapsed,
  onToggleCollapse
}) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'consultancy', label: 'Consultancy' },
    { value: 'infrastructure', label: 'Infrastructure' },
    { value: 'networking', label: 'Networking' },
    { value: 'software', label: 'Software' },
    { value: 'policy', label: 'Policy' },
    { value: 'strategy', label: 'Strategy' }
  ];

  const timelineOptions = [
    { value: 'all', label: 'Any Timeline' },
    { value: '1-2 weeks', label: '1-2 weeks' },
    { value: '1 month', label: '1 month' },
    { value: '2-3 months', label: '2-3 months' },
    { value: '3+ months', label: '3+ months' }
  ];

  const serviceTypes = [
    { id: 'consultation', label: 'Consultation' },
    { id: 'implementation', label: 'Implementation' },
    { id: 'maintenance', label: 'Maintenance' },
    { id: 'training', label: 'Training' }
  ];

  const handlePriceRangeChange = (field, value) => {
    onFilterChange('priceRange', {
      ...filters?.priceRange,
      [field]: value
    });
  };

  const handleServiceTypeChange = (typeId, checked) => {
    const updatedTypes = checked
      ? [...filters?.serviceTypes, typeId]
      : filters?.serviceTypes?.filter(type => type !== typeId);
    
    onFilterChange('serviceTypes', updatedTypes);
  };

  return (
    <div className={`bg-card border border-border rounded-lg shadow-subtle ${isCollapsed ? 'lg:block hidden' : ''}`}>
      <div className="flex items-center justify-between p-4 border-b border-border lg:hidden">
        <h3 className="text-lg font-semibold text-foreground">Filters</h3>
        <Button variant="ghost" onClick={onToggleCollapse}>
          <Icon name={isCollapsed ? "ChevronDown" : "ChevronUp"} size={20} />
        </Button>
      </div>
      <div className={`p-4 space-y-6 ${isCollapsed ? 'hidden lg:block' : ''}`}>
        {/* Search */}
        <div>
          <Input
            type="search"
            placeholder="Search services..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="w-full"
          />
        </div>

        {/* Category Filter */}
        <div>
          <Select
            label="Category"
            options={categoryOptions}
            value={filters?.category}
            onChange={(value) => onFilterChange('category', value)}
          />
        </div>

        {/* Price Range */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Price Range (UGX)
          </label>
          <div className="grid grid-cols-2 gap-3">
            <Input
              type="number"
              placeholder="Min"
              value={filters?.priceRange?.min}
              onChange={(e) => handlePriceRangeChange('min', e?.target?.value)}
            />
            <Input
              type="number"
              placeholder="Max"
              value={filters?.priceRange?.max}
              onChange={(e) => handlePriceRangeChange('max', e?.target?.value)}
            />
          </div>
        </div>

        {/* Timeline Filter */}
        <div>
          <Select
            label="Implementation Timeline"
            options={timelineOptions}
            value={filters?.timeline}
            onChange={(value) => onFilterChange('timeline', value)}
          />
        </div>

        {/* Service Types */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-3">
            Service Types
          </label>
          <div className="space-y-2">
            {serviceTypes?.map((type) => (
              <Checkbox
                key={type?.id}
                label={type?.label}
                checked={filters?.serviceTypes?.includes(type?.id)}
                onChange={(e) => handleServiceTypeChange(type?.id, e?.target?.checked)}
              />
            ))}
          </div>
        </div>

        {/* Clear Filters */}
        <div className="pt-4 border-t border-border">
          <Button
            variant="outline"
            onClick={onClearFilters}
            className="w-full"
          >
            <Icon name="X" size={16} className="mr-2" />
            Clear All Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;